import { HourType } from "../models/hourType";
import { BaseDto } from "./base/base.dto";

export class HourTypeDto extends BaseDto<HourType> {
    public id: string = "";
    public hourType: string = "";
    public wording: string = "";

    static fromBody(body: any, hourType: string): HourTypeDto {
        let hourTypeDto = new HourTypeDto();

        hourTypeDto.id = body.id;
        hourTypeDto.hourType = hourType;
        hourTypeDto.wording = body.wording;

        return hourTypeDto;
    }

    static fromModel(hourType: HourType) {
        let hourTypeDto = new HourTypeDto();

        hourTypeDto.id = hourType.id;
        hourTypeDto.hourType = hourType.hourType;
        hourTypeDto.wording = hourType.wording;

        return hourTypeDto;
    }

    public toBody() {
        const clone: any = { ...this };

        return clone;
    }

    public toModel(): HourType {
        let hourType = new HourType();

        hourType.id = this.id;
        hourType.hourType = this.hourType;
        hourType.wording = this.wording;

        return hourType;
    }
}
